import { XY } from "../../xy";
import { LootBox } from "../../things/lootBox";
import { MedicalLootBox } from "../../things/medicalLootBox";
import { MetalLootBox } from "../../things/metalLootBox";
import type { Prefab } from "../prefab";
import { buildPrefab, buildPrefabWithOverrides } from "./prefabBuilder";
import {
	building1Data,
	gasBarrelsWithFenceData,
	bloodTempleData,
	smallBloodTempleData,
	exitTo3xbCaveData,
	caveDescentData,
	vaultData,
	mobFortress1Data,
	robotFortressData,
	vendingMachineRoomData,
} from "./wastelandPrefabData";

function p(x: number, y: number): XY {
	return new XY(x, y);
}

function getVaultLoot(xy: XY): LootBox {
	const box = Math.floor(Math.random() * 3) + 1;
	if (box === 1) return new MedicalLootBox(xy);
	if (box === 2) return new MetalLootBox(xy);
	return new LootBox(xy);
}

export function getCaveDescent(levelDestination: number): Prefab {
	return buildPrefabWithOverrides(caveDescentData, {
		D: { class: "Downstairs", props: { destination: levelDestination } },
	});
}

export function getVault(): Prefab {
	const prefab = buildPrefab(vaultData);
	const lootPositions = [p(1, 1), p(2, 1), p(3, 1), p(1, 2), p(2, 2), p(3, 2)];
	for (const xy of lootPositions) {
		prefab.simpleBoard.putThing(getVaultLoot(xy));
	}
	return prefab;
}

export function getBuilding1(): Prefab {
	return buildPrefab(building1Data);
}

export function getGasBarrelsWithFence(): Prefab {
	return buildPrefab(gasBarrelsWithFenceData);
}

export function getMobFortress1(): Prefab {
	return buildPrefab(mobFortress1Data);
}

export function getRobotFortress(): Prefab {
	return buildPrefab(robotFortressData);
}

export function getBloodTemple(): Prefab {
	return buildPrefab(bloodTempleData);
}

export function getSmallBloodTemple(): Prefab {
	return buildPrefab(smallBloodTempleData);
}

export function getVendingMachineRoom(): Prefab {
	return buildPrefab(vendingMachineRoomData);
}

export function getExitTo3xbCave(destinationLevel: number): Prefab {
	return buildPrefabWithOverrides(exitTo3xbCaveData, {
		L: { class: "LadderDown", props: { destination: destinationLevel } },
	});
}
